import { __awaiter } from "tslib";
import { SolletWalletAdapter } from "@solana/wallet-adapter-sollet";
import invariant from "tiny-invariant";
export class SolflareAdapter extends SolletWalletAdapter {
    constructor() {
        super(...arguments);
        this.signAllTransactions = (txs) => __awaiter(this, void 0, void 0, function* () {
            const ret = [];
            for (let i = 0; i < txs.length; i++) {
                const tx = txs[i];
                invariant(tx, "tx");
                const signedTx = yield this.signTransaction(tx);
                ret.push(signedTx);
            }
            return ret;
        });
    }
}
//# sourceMappingURL=solflare.js.map